var api = require("!../../../style-loader@1.1.3_webpack@5.102.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../css-loader@3.6.0_webpack@5.102.1/node_modules/css-loader/dist/cjs.js!./swiper-bundle.min.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;